import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { MedicalReportProviderValidationRequest, AudiometryImmitanceCalculationRequest, RecommendationCalculationRequest, MedicalReportProviderValidationResponse } from '../models/medical-report';
import { MedicalReportRecommendationEnum } from '../models/enums';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';

@Injectable({
  providedIn: 'root'
})
export class MedicalReportDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getIsProviderLicensedAsync(request: MedicalReportProviderValidationRequest, timeout: Promise<any>): Promise<MedicalReportProviderValidationResponse> {
    return this.httpClient.getJsonAsync('MedicalReport/GetIsProviderLicensed', request, timeout);
  }

  public getAudiometryImmitanceChangesAsync(request: AudiometryImmitanceCalculationRequest, timeout: Promise<any>): Promise<any> {
    return this.httpClient.getJsonAsync('MedicalReport/GetAudiometryImmitanceChanges', request, timeout);
  }

  public getRecommendationHaNeededAsync(request: RecommendationCalculationRequest, timeout: Promise<any>): Promise<MedicalReportRecommendationEnum> {
    return this.httpClient.getJsonAsync('MedicalReport/GetRecommendationHaNeeded', request, timeout);
  }

  public downloadFileBlobAsync(id: number, timeout: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('MedicalReport/Print', {id}, timeout);
  }
}
